import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=80a05664&scoped=true&"
import script from "./Overlay.vue?vue&type=script&lang=js&"
export * from "./Overlay.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/overlay.css?vue&type=style&index=0&id=80a05664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a05664",
  null
  
)

export default component.exports